module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 026.46927541.jpg";